import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { strictEqual } from 'assert';
import { SendChatCommunication } from 'src/app/core/model/v2/chat/save-chat';
import { Patient } from 'src/app/core/models/patient/patient';
import { ChatService } from 'src/app/core/services/v2/chat.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { debug } from 'util';
import { PhysicianOptionService } from '../../shared/physician-option/physician-option.service';

@Component({
  selector: 'app-send-message',
  host: {
    "(window:paste)": "handlePaste( $event )"
  },
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent implements OnInit {
  @ViewChild('chatmsg', { static: false }) chatinput;
  @Input() sectionName: string;
  @Input() patientData: Patient;
  @Input() employerId: number;
  @Output() cancelEvent = new EventEmitter();
  @Output() toggleEvent = new EventEmitter();
  public imageUrls: SafeUrl[];
  private lastObjectUrl: string;
  private sanitizer: DomSanitizer;


  chatCommunication: SendChatCommunication = new SendChatCommunication();

  constructor(private physicianOptionService: PhysicianOptionService,
    private chatService: ChatService,
    private loaderService: WindowLoaderService,
    sanitizer: DomSanitizer  ) {
    this.sanitizer = sanitizer;

		this.imageUrls = [];
		this.lastObjectUrl = "";
  }

  ngOnInit() {
    
    this.chatCommunication.toPatientIds = [];
  }
  sendCommunication() {
    
    this.chatCommunication.content = this.chatinput.nativeElement.innerHTML == "" ? this.chatinput.nativeElement.value : this.chatinput.nativeElement.innerHTML;
    let indx=this.chatCommunication.toPatientIds.findIndex(x => x == this.patientData.id);
    if (indx == -1) {
      this.chatCommunication.toPatientIds.push(this.patientData.id);
    }
    this.chatCommunication.practitionerId = this.physicianOptionService.getPhysician().id == undefined ? 0 : this.physicianOptionService.getPhysician().id;
    this.chatCommunication.employerId = this.employerId;
    this.loaderService.show();
    this.chatService.sendCommunication(this.chatCommunication).subscribe(
      (_) => { this.loaderService.hide();this.toggleEvent.emit() },
      (error) => { console.error(error); this.loaderService.hide();},
      () => { this.loaderService.hide(); }
    );
  }

}
